import { render } from "./BaseViewVisitor.vue?vue&type=template&id=70ebf584&scoped=true"
import script from "./BaseViewVisitor.vue?vue&type=script&lang=js"
export * from "./BaseViewVisitor.vue?vue&type=script&lang=js"

import "./BaseViewVisitor.vue?vue&type=style&index=0&id=70ebf584&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ebf584"]])

export default __exports__